export default{
  // baseURL: 'http://192.168.42.149:8080/jeecg-boot',
  // baseURL: 'http://39.103.162.59:8080/jeecg-boot',
  baseURL: 'http://admin.winstar-bio.com/jeecg-boot',

}



// WEBPACK FOOTER //
// ./src/api/api.js